import { CONFIG } from './config'

export const WORDS = [
  'niyam',
  "loma'",
  'ciira',
  'anini',
  'lotok',
  'nanom',
  'tayal',
  'kilang',
  'kapah',
  'panay',
  'sowal',
  'fodoy',
  'lalan',
  'naira',
  'awaay',
  'kolong',
  'tireng',
  'singsi',
  'kamay',
  'foting',
  'caira',
  'mayaw',
  'demak',
  'fafoy',
  'codad',
  "'ayam",
  'cecay',
  "'ayaw",
  'kacaw',
  'adada',
  'riyar',
  "'orip",
  'hemay',
  "wa'ay",
  "to'as",
  'rakat',
  'tayra',
  'sapad',
  'fanaw',
  'pising',
  'dafak',
  'kapot',
  'payso',
  'kawas',
  'kaying',
  'lafang',
  'fiyaw',
  'sanay',
  'tangal',
  'potal',
  'tomok',
  'kasoy',
  'tomay',
  "'awol",
  "'orad",
  'cidal',
  "doka'",
  "'oner",
  'widang',
  'hawan',
  'dateng',
  'pawli',
  'fokes',
  'miala',
  'felac',
  'tayni',
  "'icep",
  'semot',
  "fana'",
  'piyang',
  "nga'ay",
  "po'ot",
  'papah',
  'pawti',
  'mamang',
  'wadis',
  'impic',
  'tiyad',
  'kolas',
  'itini',
  'cacay',
  'kikay',
  'radiw',
  'cengel',
  "riko'",
  'lamal',
  "maro'",
  'ngangan',
  'dangah',
  'niira',
  'folad',
  "koko'",
  'parod',
  'dipot',
  'lawac',
  'simal',
  'toray',
  'foday',
  'roray',
  'nanay',
]

if (CONFIG.normalization) {
  WORDS.forEach((val, i) => (WORDS[i] = val.normalize(CONFIG.normalization)))
}

function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

if (CONFIG.shuffle) {
  shuffle(WORDS)
}
